import { render, staticRenderFns } from "./AddPreference.vue?vue&type=template&id=388f9bd3&scoped=true"
import script from "./AddPreference.vue?vue&type=script&lang=js"
export * from "./AddPreference.vue?vue&type=script&lang=js"
import style0 from "./AddPreference.vue?vue&type=style&index=0&id=388f9bd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f9bd3",
  null
  
)

export default component.exports